// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg--disabled[data-v-2052c7a9] {\n  background: #FBFBFB;\n}\n.border-top--color[data-v-2052c7a9] {\n  border-top: 1px solid #EEEEEE;\n}\n", ""]);
// Exports
module.exports = exports;
